import React from "react";

const FAQS = [
  { q: "Who is Kids Biz Boss for?", a: "Kids ages 7 to 15 who want to try running a business. Younger kids can play with a grown-up; older kids will enjoy the pricing, marketing and rival strategy." },
  { q: "Is it really free?", a: "Yes. The Dog Walker business is free forever, with its mini-game, customers, lessons and the leaderboard. A parent can unlock Babysitter, Craft Maker and Lawn Mower for a one-time $8.99." },
  { q: "What does a kid actually learn?", a: "Real money basics: how to set a fair price, why supplies are an expense, that profit is what's left after costs, how reviews bring more customers, and how saving in a piggy bank earns interest over time." },
  { q: "Who is Riley?", a: "Riley is the rival kid down the street. Riley's prices and reviews change every day, and Riley will win customers if your prices are too high or your rating drops. Beat Riley's week to earn a Top Boss trophy." },
  { q: "Can my child play on another device?", a: "Yes. Tap Save & Load to get a short save code like KBB-XXXX-XXXX, then enter it on any device to continue the same game." },
  { q: "Is it safe for kids?", a: "There are no accounts, ads or chat. Only a first name and avatar appear on the leaderboard, and inactive save codes and scores are automatically deleted." },
];

const LandingFaq = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-testid="landing-faq">
    <div className="text-xs font-black uppercase tracking-widest text-amber-600 mb-2">Questions</div>
    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight mb-6">Parents and kids ask us</h2>
    <div className="grid md:grid-cols-2 gap-4">
      {FAQS.map((f, i) => (
        <details key={i} className="group bg-white rounded-2xl border-2 border-slate-200 p-4 sm:p-5 open:border-amber-300" data-testid={`landing-faq-${i + 1}`}>
          <summary className="cursor-pointer list-none font-heading font-black text-base sm:text-lg text-slate-900 flex items-center justify-between gap-3">
            {f.q}
            <span className="text-amber-500 text-xl transition-transform group-open:rotate-45">+</span>
          </summary>
          <p className="mt-3 text-sm sm:text-base text-slate-600 font-medium leading-relaxed">{f.a}</p>
        </details>
      ))}
    </div>
  </section>
);

export default LandingFaq;
